import { DefaultService } from '@/services/DefaultService';

export default class FormPerguntaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    delete(id, contexto = "pro") {
        return this._http.delete(`${this._env}/${contexto}/formPergunta/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}